
import Api2Talk from "../api2talk";

const PATH = '/chatbot-flow';

const create = async (input) => { 
  try {
    const response = await Api2Talk.post(PATH, input);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const update = async (input) => { 
  try {
    const response = await Api2Talk.put(PATH, input);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getAllPaginate = async (page, chatbotid) => {
  try {
    const response = await Api2Talk.get(`${PATH}/paginate?page=${page}&chatbot_id=${chatbotid}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getList = async (chatbotid, chatbotflowid) => {
  try {
    const response = await Api2Talk.get(`${PATH}/get-list/${chatbotflowid}?chatbot_id=${chatbotid}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getById = async (id) => {
  try {
    const response = await Api2Talk.get(`${PATH}/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getJsonFlowById = async (id) => {
  try {
    const response = await Api2Talk.get(`${PATH}/get-json-flow/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const addJsonFlow = async (input) => {
  try {
    const response = await Api2Talk.put(`${PATH}/add-json-flow`, input);
    return response.data;
  } catch (err) {
    throw err;
  }
}

// Item 10 (17/10/2026) — valida o fluxo do canvas (mesmo validador do copiloto). Só informa; não bloqueia o save.
const validateFlow = async (id, jsonflow) => {
  try {
    const response = await Api2Talk.post(`${PATH}/${id}/validate`, { jsonFlow: jsonflow });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const deleteById = async (id) => {
  try {
    const response = await Api2Talk.delete(`${PATH}/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getItemsSelect = async (id, type) => {
  try {
    const response = await Api2Talk.get(`${PATH}/fetch-items-select/${id}?type=${type}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getVariablesAndCustomFields = async () => {
  try {
    const response = await Api2Talk.get(`${PATH}/get-variables-and-custom-fields`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

// F7 Fase 1 — endpoint unificado de placeholders (6 categorias: param, variable,
// customField, chat, system, session). Substitui gradualmente
// getVariablesAndCustomFields (que só devolve 3 categorias).
const getPlaceholders = async () => {
  try {
    const response = await Api2Talk.get(`${PATH}/get-placeholders`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

// F7 Fase 1 (Opção B #1) — templates prontos da caixa Condicional.
const getConditionTemplates = async () => {
  try {
    const response = await Api2Talk.get(`${PATH}/get-condition-templates`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

// F7 Fase 1 (Opção B #2) — avalia regras da caixa Condicional em preview
// (sem publicar fluxo). Recebe rules + chatId opcional; devolve porta + trace.
const previewCondition = async (payload) => {
  try {
    const response = await Api2Talk.post(`${PATH}/condition-preview`, payload);
    return response.data;
  } catch (err) {
    throw err;
  }
}

export {
  validateFlow,
  addJsonFlow, create,
  deleteById,
  getAllPaginate,
  getById, getItemsSelect, getJsonFlowById, getList, update,
  getVariablesAndCustomFields, getPlaceholders,
  getConditionTemplates, previewCondition
};

